import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { SegmentedNavigationItemComponent } from './components/segmented-navigation-item/segmented-navigation-item.component';
import { SegmentedNavigationComponent } from './segmented-navigation.component';

@NgModule({
  declarations: [
    SegmentedNavigationItemComponent,
    SegmentedNavigationComponent,
  ],
  exports: [SegmentedNavigationComponent],
  imports: [CommonModule, NgxBootstrapIconsModule],
})
export class SegmentedNavigationModule {}
